module.exports = __webpack_public_path__ + "img/report_tejrb.6c2da539.png";